import { Stack } from '@chakra-ui/react';
import { Order } from '@diamond/shared/types';
import { CardPromoInfo } from '@diamond/shared/ui';
import { extractOrderVoucherBannerData } from '@diamond/sol-buyer/utils';

interface OrderVoucherBannerSummaryProps {
  order: Order;
}

export const OrderVoucherBannerSummary = ({
  order,
}: OrderVoucherBannerSummaryProps) => {
  const orderProducts = order.items.flatMap((item) => item.products);
  const voucherBanners = extractOrderVoucherBannerData(
    order.vouchers?.applied_vouchers ?? [],
    orderProducts
  );

  if (voucherBanners.length === 0) {
    return null;
  }

  return (
    <Stack spacing="4" mt="4" px={{ base: 0, md: 6 }}>
      {voucherBanners.map((banner) => (
        <CardPromoInfo
          key={banner.voucherId}
          type={banner.type}
          duration={banner.dateRange}
          text={banner.text}
          item={banner.item!}
          images={banner.images}
          savings={banner.savings}
          showFreeItemPrice={false}
          showVoucherIcon
        />
      ))}
    </Stack>
  );
};
